"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrorMessage = void 0;
var __1 = require("..");
function handleErrorMessage(error) {
    var errorMessage = "Failed to do something exceptional";
    if (error instanceof Error) {
        errorMessage = error.message;
    }
    __1.showErrorDialog(errorMessage);
}
exports.handleErrorMessage = handleErrorMessage;
